import { EndpointBuilder } from "@reduxjs/toolkit/query";
import { marketplaceFilters } from "@shared/slices/filters.slice";
import {
  ApiGeneralDataResponse,
  ApiResponse,
  ApiTags,
  MarketplaceResponse,
  SubGroupOverview,
  SubGroupOverviewRequest,
  SubGroupOverviewResponse,
  SubGroupReviewsData,
  SubGroupReviewsRequest,
  SubGroupReviewsResponse,
  SubGroupSetReviewRequest,
} from "@shared/types";

export const marketplaceEndpoints = {
  endpoints: (build: EndpointBuilder<any, any, any>) => ({
    getMarketplaceInfo: build.query<MarketplaceResponse, void>({
      query: () => ({
        url: "get_marketplace_info/",
        method: "POST",
        body: { add_extra_info: true },
      }),
      transformResponse: (response: ApiResponse<MarketplaceResponse>) => {
        return response.data || { data: [], headers: [] };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(marketplaceFilters.actions.loadFilters({ data }));
        } catch {}
      },
      keepUnusedDataFor: 0,
    }),
    getGroupOverview: build.query<SubGroupOverview, SubGroupOverviewRequest>({
      query: (args) => ({
        url: "get_group_overview/",
        method: "POST",
        body: args,
      }),
      transformResponse: (response: ApiResponse<SubGroupOverviewResponse>) =>
        response.data?.data,
    }),
    getGroupReviews: build.query<SubGroupReviewsData, SubGroupReviewsRequest>({
      query: (args) => ({
        url: "get_group_reviews/",
        method: "POST",
        body: args,
      }),
      keepUnusedDataFor: 0,
      transformResponse: (response: ApiResponse<SubGroupReviewsResponse>) =>
        response.data?.data,
      providesTags: () => [{ type: ApiTags.SUBGROUP_REVIEWS, id: "LIST" }],
    }),
    setGroupReview: build.mutation<void, SubGroupSetReviewRequest>({
      query: (args) => ({
        url: "set_group_review/",
        method: "POST",
        body: args,
      }),
      invalidatesTags: [{ type: ApiTags.SUBGROUP_REVIEWS, id: "LIST" }],
    }),
    getUserGroupData: build.query<void, { group_id: number }>({
      query: (args) => ({
        url: "get_user_group_data/",
        method: "POST",
        body: args,
      }),
      keepUnusedDataFor: 0,
      transformResponse: (response: ApiResponse<ApiGeneralDataResponse<any>>) =>
        response.data?.data,
    }),
    getUserGroupsSubscriptions: build.query<void, void>({
      query: (args) => ({
        url: "get_user_groups_subscriptions/",
        method: "POST",
        body: args,
      }),
      transformResponse: (response: ApiResponse<ApiGeneralDataResponse<any>>) =>
        response.data?.data,
    }),
    getMarketplaceInfoFull: build.query<MarketplaceResponse, void>({
      query: () => ({
        url: "get_marketplace_info_full/",
        method: "POST",
        body: { add_extra_info: true },
      }),
      transformResponse: (response: ApiResponse<MarketplaceResponse>) => {
        return response.data || { data: [], headers: [] };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            marketplaceFilters.actions.loadFilters({ data, forceLoad: true })
          );
        } catch {}
      },
      keepUnusedDataFor: 0,
    }),
  }),
};
